/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {SettlementDetailAgreementConfigurationModel} from '../services/settlement-detail-configuration/models/settlement-detail-agreement-configuration.model';
import {CurrencyBaseContract} from '../api/contracts/currency-base.contract';
import {SettlementDetailAcceptanceCommentModel} from '../services/settlement-detail-configuration/models/settlement-detail-acceptance-comment.model';
import {SettlementStatusEnum} from '../models/settlement-status.enum';
import {formatWithCurrencySymbol} from '../shared/util/financial-number/financial-number-helper';

@Component({
    selector: 'app-settlement-agreement',
    templateUrl: './settlement-agreement.component.html',
    styleUrls: ['./settlement-agreement.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SettlementAgreementComponent {
    @Input() agreement: SettlementDetailAgreementConfigurationModel;
    @Input() acceptanceComment?: SettlementDetailAcceptanceCommentModel;

    readonly LABEL_TOTAL: string = 'Total:';
    readonly LABEL_CONTACT_MANAGER: string = 'BCS contact manager';
    readonly AGREEMENT_TOTAL_GROSS_AMOUNT: string = 'Agreement total gross amount';

    get hasAgreementDecision(): boolean {
        return this.agreement?.data?.decision?.decisionReason != null
            && this.agreement?.data?.decision?.decidedBy != null;
    }

    get isRejected(): boolean {
        return this.hasAgreementDecision
            && this.agreement?.agreementStatus === SettlementStatusEnum.REJECTED;
    }

    get isAccepted(): boolean {
        return this.agreement?.data?.decision?.decidedBy != null &&
            this.agreement.agreementStatus === SettlementStatusEnum.ACCEPTED;
    }

    financialNumberText(value: number, currency: CurrencyBaseContract): string {
        return formatWithCurrencySymbol(value, currency?.alphabeticCode);
    }
}
